import { render, staticRenderFns } from "./DataTable.component.vue?vue&type=template&id=2c6f9802"
import script from "./DataTable.component.ts?vue&type=script&lang=js&external"
export * from "./DataTable.component.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6f9802')) {
      api.createRecord('2c6f9802', component.options)
    } else {
      api.reload('2c6f9802', component.options)
    }
    module.hot.accept("./DataTable.component.vue?vue&type=template&id=2c6f9802", function () {
      api.rerender('2c6f9802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/iot-simulator/DataTable.component.vue"
export default component.exports